/** Funtions to assist with the filtering of options
 * using the criteria of airline name.
 *
 * Note: Using validatingServiceProvider (vs serviceProvider for each service)
 *
 */
import {
  List,
  Map
} from 'immutable'

/** Produces a Map of airline names, keyed by airline industry identifier */
export const createAirlinesIndex = (offers = List()) =>
  offers.reduce((idx, offer) => {
    const industryIdentifier = offer.getIn(['validatingServiceProvider', 'industryIdentifier'])
    const airlineName = offer.get('validatingServiceProvider').has('name')? offer.get('validatingServiceProvider').get('name') : industryIdentifier.get('identifier')
    const offerCost = offer.getIn(['cost','amount'])
    return idx.update( industryIdentifier.get('identifier'), (airlineInfo = Map()) =>
            airlineInfo.update('lowest', prevLow => {
                return prevLow == null || offerCost < prevLow
                    ? offerCost
                    : prevLow
            })
            .update( 'highest', prevHigh => {
                return prevHigh == null || offerCost > prevHigh
                    ? offerCost
                    : prevHigh
            })
            .update('name', val => airlineName)
        )
  }, Map()).sortBy((v,k) => v, (a,b) => a.get('name') < b.get('name') ? -1 : 1)

/** For the given seq of airline identifier produces a predicate
 * function that only matches offers with that validating service provider.
 */
export const airlinesPredicate = (airlines = Set()) => (offer = Map()) =>
    airlines.includes(offer.getIn(['validatingServiceProvider', 'industryIdentifier', 'identifier']))



// WEBPACK FOOTER //
// ./src/ndc/offer/filters/airlines/airlines.js